import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, IconButton, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InfoTooltip = () => {
    const { t } = useTranslation();
    return (
        <Tooltip
            title={t("footer")}
            arrow
            enterTouchDelay={0}          // ➜ s'affiche immédiatement au toucher
            leaveTouchDelay={3000}       // ➜ reste affiché plus longtemps (3 s ici)
            disableInteractive           // ➜ empêche le tooltip de rester bloqué au toucher
            placement="top"
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: 'var(--gray)',
                        color: '#fff',
                        fontSize: '0.85rem',
                        textAlign: "center",
                        lineHeight:1.2,
                        maxWidth: 370,
                        p: 1.5,
                        borderRadius: '8px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    },
                },
                arrow: {
                    sx: {
                        color: 'var(--gray)',
                    },
                },
            }}
        >
            <IconButton
                size="small"
                sx={{
                    p: 0.5,
                    border: '1px solid var(--gray)',
                    borderRadius: '50%',
                    width: 22,
                    height: 22,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                        backgroundColor: '#5150491a',
                    },
                }}
            >
                <Box
                    component="span"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        '& svg': {
                            width: '4px',
                            height: 'auto',
                            fill: 'var(--gray)',
                        },
                    }}
                    dangerouslySetInnerHTML={{
                        __html: `
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.483" height="43.681" viewBox="0 0 15.483 43.681">
                            <path d="m12.617,13.078l-6.522,23.092c-.439,1.559-.659,2.493-.659,2.8,0,.351.104.637.313.856s.456.329.741.329c.329,0,.725-.176,1.186-.527,1.252-.988,2.515-2.394,3.788-4.217l1.153.758c-1.493,2.284-3.25,4.206-5.271,5.765-1.493,1.164-2.921,1.746-4.282,1.746-.9,0-1.636-.269-2.207-.807s-.856-1.213-.856-2.026.275-2.163.824-4.052l4.282-14.758c.703-2.416,1.054-3.931,1.054-4.546,0-.483-.17-.878-.511-1.186s-.807-.461-1.4-.461c-.483,0-1.482.121-2.998.362v-1.285l11.365-1.845Zm-.428-13.078c.922,0,1.702.318,2.339.955s.955,1.416.955,2.339c0,.9-.324,1.675-.972,2.322s-1.422.972-2.322.972-1.675-.324-2.322-.972-.972-1.422-.972-2.322c0-.922.318-1.702.955-2.339s1.416-.955,2.339-.955Z"/>
                        </svg>
                        `,
                    }}
                />
            </IconButton>
        </Tooltip>
    );
};

export default InfoTooltip;
